var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-test-id":"user-reviews"}},_vm._l((_vm.visibleReviews),function(review){return _c('user-review',{key:review.name,staticClass:"mb-8",attrs:{"review":review}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }